module.exports = __webpack_public_path__ + "static/media/weigh_tickets_active_es.9aca8bc5.svg";